export default {
  isRequestInProgress: state => {
    if (state.requestTokens && state.requestTokens.length > 0) {
      return true;
    } else {
      return false;
    }
  },
};
